import {
  ControlLayoutModel,
  ControlDataModel,
  AbstractControl,
  ControlLayoutHost,
  DynamicControlContainer
} from './control.types';

/**
 * æ§ä»¶å è½½model
 *
 */
export class LoadComponentModel {
  /**
   * å¸å±model
   *
   */
  layoutModel: ControlLayoutModel | ControlDataModel[];

  /**
   * ç¶å®¹å¨
   *
   */
  dynamicControlContainer: DynamicControlContainer;
  /**
   * è®¾è®¡ç¶æ undefined å­ç»ä»¶æ¯true
   *
   */
  isDesign?: boolean;
  /**
   * ç»ä»¶å è½½ååè°
   *
   */
  result?: (s: AbstractControl<any> | AbstractControl<any>[]) => void;
}
